import React, { useEffect } from "react";
import { useNetwork } from "ahooks";
import { InformationBarWarnStrong } from "./weui/InformationBar";
import { motion, AnimatePresence } from "framer-motion";

function NetworkStateBar({
  onShow,
  onClose,
}: {
  onShow?: () => void;
  onClose?: () => void;
}) {
  const networkState = useNetwork();
  useEffect(() => {
    if (!networkState.online) {
      if (onShow) {
        onShow();
      }
    } else {
      if (onClose) {
        onClose();
      }
    }
  }, [networkState.online, onClose, onShow]);

  return (
    <>
      {!networkState.online && (
        <InformationBarWarnStrong
          message="未连接到网络"
          fixed={false}
          rounded={false}
          showClose={false}
        />
      )}
      {/* 下show上hidden 但下面的元素会因为本元素占位而卡顿 */}
      {/* <AnimatePresence>
        {!networkState.online && (
          <motion.nav
            initial={{ y: "-100%", opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: "-100%", opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <InformationBarWarnStrong
              message="未连接到网络"
              fixed={false}
              rounded={false}
              showClose={false}
            />
          </motion.nav>
        )}
      </AnimatePresence> */}
    </>
  );
}

export default NetworkStateBar;
